import type { Root } from './prototypeTypes';
import type { MediaKind } from './mediaPlayerTypes';
import { dismissToastById } from './toastController';

const PLAYBACK_START_RETRY_TOAST_ID = 'playbackStartRetryToast';

function retryOverlay(root: Root): HTMLElement | null {
	const doc = root instanceof Document ? root : root.ownerDocument ?? document;
	return doc.getElementById('vfPlaybackRetry');
}

export function clearPlaybackStartRetry(root: Root, kind: MediaKind): void {
	dismissToastById(PLAYBACK_START_RETRY_TOAST_ID);
	if (kind === 'video') retryOverlay(root)?.setAttribute('hidden', '');
}

/**
 * A token request necessarily crosses an async boundary. Some Android
 * browsers then reject HTMLMediaElement.play() because the original tap's
 * transient activation has expired. Keep the mounted, authorised source and
 * give the user a second, real gesture instead of presenting a paused player
 * as if playback had started. No toast: the video surface keeps its in-player
 * retry control and audio keeps the dock's play button — a global popup for a
 * playable-in-place state was noise (product decision).
 */
export function presentPlaybackStartRetry(root: Root, kind: MediaKind, _retry: () => void): void {
	if (kind === 'video') retryOverlay(root)?.removeAttribute('hidden');
}
